import { MobileOS, OS } from "./types";

export function getMobileOS(): MobileOS {
  const userAgent = navigator.userAgent || navigator.vendor;

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return MobileOS.iOS;
  }

  return MobileOS.Android;
}

export function getOS(): OS {
  const userAgent = navigator.userAgent || navigator.vendor;

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return "iOS";
  }

  return "Android";
}

export function getStoreLink(): string {
  const map: { [key in OS]: string } = {
    Android:
      "https://play.google.com/store/apps/details?id=com.greeenballoon.figurinhas",
    iOS: "https://apps.apple.com/us/app/figurinhas-web-app/id6447811229",
  };

  const os = getOS();

  return map[os];
}
